export default {"src":"/_next/static/media/PG.15751c9e.svg","height":18,"width":18};